/**
 * @param {number} value value that needs to be mapped
 * @param {Object} input reference array [start, end] to map value from
 * @param {Object} output reference array [start, end] to map value to
 */
export function mapRange(value, input, output) {
  return ((value - input[0]) * (output[1] - output[0])) / (input[1] - input[0]) + output[0];
}
